<template>
  <div class="bg" style="background: url(static/img/background.jpg)">
    <v-container grid-list-lg class="mb-5 responsive-container">
      <v-layout row justify-center wrap>
        <BackSimulator></BackSimulator>
        <v-flex xs12 md6 lg4>
          <img src="static/logo/logo.svg" width="60%" class="mx-auto mt-2" />
        </v-flex>
        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">Dados Pessoais</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Nome *</p>
                    <v-text-field
                      ref="nome"
                      solo
                      hide-details
                      v-model="form.nome"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.telefone.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Telefone *</p>
                    <v-text-field
                      ref="telefone"
                      type="tel"
                      inputmode="tel"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                      v-model="form.telefone"
                      placeholder="(00) 00000-0000"
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.email.focus()"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">E-mail *</p>
                    <v-text-field
                      ref="email"
                      type="email"
                      solo
                      hide-details
                      v-model="form.email"
                      :error="emailError"
                      :error-messages="emailError ? ['E-mail inválido'] : []"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.empresa.focus()"
                      @blur="validateEmail"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Empresa (Razão Social) *</p>
                    <v-text-field
                      ref="empresa"
                      solo
                      hide-details
                      v-model="form.empresa"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.cargo.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-left">
                    <p class="caption mb-2">Cargo *</p>
                    <v-text-field
                      ref="cargo"
                      solo
                      hide-details
                      v-model="form.cargo"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="$refs.custo.focus()"
                      @input="saveLocal"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <h1 class="text-xs-center font-weight-medium">
            Formulário de Iluminação
          </h1>
        </v-flex>
        <v-flex xs12>
          <v-card class="card-custom mb-2">
            <v-card-text class="card-custom-text">
              <v-container fluid>
                <v-layout row wrap align-end>
                  <v-flex xs12 sm12 md6 lg4 class="text-xs-left">
                    <p class="caption mb-2">Custo da Energia (R$/MWh) *</p>
                    <v-text-field
                      ref="custo"
                      v-model="form.custo"
                      v-money="money"
                      solo
                      hide-details
                      inputmode="decimal"
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="
                        $refs.quantidade && $refs.quantidade.focus()
                      "
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg4 class="text-xs-left">
                    <p class="mb-3 mt-0">(Energia + Encargos + Impostos)</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          v-for="(item, index) in equipamentos"
          :key="index"
          class="mb-4"
        >
          <v-card class="card-custom">
            <v-card-text class="card-custom-text">
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6 lg3 class="text-xs-left">
                    <p class="caption mb-2">Dias de Operação no Mês *</p>
                    <v-select
                      v-model="item.dias_operacao"
                      solo
                      hide-details
                      :items="dias_mes"
                    >
                    </v-select>
                    <!-- <v-text-field
                      ref="horas_ano"
                      type="number"
                      inputmode="numeric"
                      v-model="item.horas"
                      v-mask="'####'"
                      placeholder="Ex.: 4000"
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                      @blur="validateHorasAno(item)"
                    /> -->
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg3 class="text-xs-left">
                    <p class="caption mb-2">Horas de Operação (horas/dia) *</p>
                    <v-select
                      v-model="item.horas_operacao"
                      solo
                      hide-details
                      :items="horas_dias"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg3 class="text-xs-left">
                    <p class="caption mb-2">Aplicação *</p>
                    <v-select
                      v-model="item.aplicacao"
                      :items="application"
                      solo
                      hide-detail
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg3 class="text-xs-left">
                    <p class="caption mb-2">Tecnologia *</p>
                    <v-select
                      v-model="item.tecnologia"
                      :items="technology"
                      solo
                      hide-detail
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md6 lg2 class="text-xs-left">
                    <p class="caption mb-2">Quantidade *</p>
                    <v-text-field
                      ref="quantidade"
                      type="number"
                      inputmode="numeric"
                      v-model="item.quantidade"
                      :attrs="{ returnKeyType: 'next' }"
                      solo
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs10 sm11 md5 lg2 class="text-xs-left">
                    <p class="caption mb-2">Potência Nominal (W) *</p>
                    <!-- <v-text-field v-model="item.potencia" solo hide-details /> -->
                    <v-text-field
                      ref="potencia"
                      type="number"
                      inputmode="numeric"
                      v-model="item.potencia"
                      solo
                      hide-details
                      :attrs="{ returnKeyType: 'next' }"
                      @keyup.enter="
                        $refs.tensao &&
                          $refs.tensao[index] &&
                          $refs.tensao[index].focus()
                      "
                    />
                    <v-tooltip top v-if="index !== 0">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          class="ml-auto mr-1"
                          style="position: absolute; top: 0; right: 4px"
                          v-on="on"
                          @click="removeCard(index)"
                        >
                          <v-icon>mdi mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex xs1>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          color="primary"
                          class="ml-auto mr-1 btn-plus"
                          v-on="on"
                          @click="addCard"
                        >
                          <v-icon>mdi mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="text-xs-right pb-5">
          <v-btn color="primary" @click="sendForm()">
            Enviar dados
            <v-icon right>mdi mdi-send</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
try {
  var _base = require("@/page/_base.vue").default;
} catch (err) {
  var _base = require("@/framework/page/_base.vue").default;
}

import { VMoney } from "v-money";

import BackSimulator from "@/page/widget/backSimulator.vue";

import Swal from "sweetalert2";
import { mask } from "vue-the-mask";
export default {
  extends: _base,

  data() {
    return {
      dias_mes: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      horas_dias: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24,
      ],
      form: {
        nome: "",
        telefone: "",
        email: "",
        empresa: "",
        cargo: "",
        custo: 0,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 2,
        masked: false,
      },
      emailError: false,
      equipamentos: [],
      application: ["Interno", "Externo"],
      technologyANTIGO: [
        "Fluorescente Tubular T12",
        "Fluorescente Tubular T8",
        "Fluorescente Tubular T5",
        "Vapor de Mercúrio",
        "Vapor Metálico",
        "Sódio de Alta Pressão",
        "LED (2008 - 2015)",
        "LED (2016 - 2020)",
        "LED (2021 em diante)",
      ],
      technology: [
        "Flurescente tubular t8/t10/t12",
        "Vapor metálico",
        "Vapor de sódio",
        "Flurescente tubular t5",
        "Fluorescente compacta pl",
        "Lâmpada tubular led",
        "Luminária led",
      ],
      endpoint: global.config.endpoint,
    };
  },
  directives: { mask },
  methods: {
    validateYear(item) {
      const year = Number(item.ano);
      const currentYear = new Date().getFullYear();

      if (year < 1821 || year > currentYear) {
        item.ano = "";
        item.ano_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Ano de Fabricação</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1821</b> e <b style="font-weight: bold !important;">${currentYear}</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.ano_error = false;
      }
    },
    validateHours(item) {
      const horas = Number(item.horas_operacao_dia);

      if (!horas || horas <= 0 || horas > 24) {
        item.horas_operacao_dia = "";
        item.horas_operacao_dia_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Horas de Operação por Dia</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1</b> e <b style="font-weight: bold !important;">24</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.horas_operacao_dia_error = false;
      }
    },
    validateHorasAno(item) {
      const horas = Number(item.horas);
      const MAX_HORAS_ANO = 8760; // 365 dias x 24h

      if (!horas || horas < 1 || horas > MAX_HORAS_ANO) {
        item.horas = "";

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Horas de Operação no Ano</strong>",
          html: `
        <div style="padding: 10px;">
          <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
            Informe um valor entre <span style="font-weight: bold !important;">1</span> e <span style="font-weight: bold !important;">${MAX_HORAS_ANO}</span> horas.
          </p>
        </div>
      `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      }
    },
    validateDias(item) {
      const dias = Number(item.dias_operacao_ano);

      if (!dias || dias <= 0 || dias > 365) {
        item.dias_operacao_ano = "";
        item.dias_operacao_ano_error = true;

        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Dias de Operação no Ano</strong>",
          html: `
            <div style="padding: 10px;">
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                Deve ser entre <b style="font-weight: bold !important;">1</b> e <b style="font-weight: bold !important;">365</b>.
              </p>
              <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">Este campo não pode estar vazio</p>
            </div>
          `,
          confirmButtonText: "Corrigir agora!",
          confirmButtonColor: "#d33",
        });
      } else {
        item.dias_operacao_ano_error = false;
      }
    },
    async sendForm() {
      let error = "";

      if (this.validaequipamentos()) {
        error = "Preencha todos os campos dos equipamentos!";
      }

      if (this.emailError) {
        error = "Por favor, informe um e-mail válido";
      }

      if (this.form.cargo == "") {
        error = "Informe o cargo";
      }

      if (this.form.empresa == "") {
        error = "Informe a razão social";
      }

      if (this.form.email == "") {
        error = "Inserir o e-mail";
      }

      if (this.form.telefone == "") {
        error = "Informe o telefone";
      }
      if (this.form.nome == "") {
        error = "Informa o nome";
      }

      if (error != "") {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Finalize o preenchimento!</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                       ${error}
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      const formData = {
        form: this.form,
        equipamentos: this.equipamentos,
      };

      console.log("Dados a serem enviados:", formData);
      Swal.showLoading();

      let valores = JSON.stringify(formData);

      let res = await this.callLocalAction("save_estudo", {
        dados: valores,
      });

      if (res && res.ok && res.ok.ok) {
        Swal.fire({
          icon: "success",
          title:
            "<strong style='font-size: 20px !important;'>Resultado enviado</strong>",
          html: `
              <div style="padding: 10px;">
                  <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                    O resultado da simulação foi enviado para o e-mail informado: <b>${this.form.email}</b>
                  </p>
                </div>
            `,
          confirmButtonText: "Ok",
          confirmButtonColor: "#68b842",
        });
      } else {
        Swal.fire({
          icon: "error",
          title:
            "<strong style='font-size: 20px !important;'>Erro ao salvar</strong>",
          html: `
                <div style="padding: 10px;">
                    <p style="font-size: 16px !important; line-height: 1.5; font-weight: 500 !important;">
                      Não foi possível realizar o estudo
                    </p>
                </div>
            `,
          confirmButtonText: "Ok",
        });

        return;
      }

      // alert("Formulário enviado com sucesso! (Dados no console)");

      // Aqui você pode adicionar a lógica para enviar os dados para um servidor
      // Ex: axios.post('/api/iluminacao', formData)
      //   .then(response => {
      //     console.log('Sucesso:', response.data);
      //     alert('Formulário enviado com sucesso!');
      //     localStorage.removeItem('iluminacao_form'); // Limpa o localStorage após o envio
      //     // Opcional: resetar o formulário
      //     this.form = { nome: "", telefone: "", email: "", empresa: "", cargo: "" };
      //     this.equipamentos = [{ quantidade: "", aplicacao: "", tecnologia: "", ano: "", horas: "", potencia: "" }];
      //   })
      //   .catch(error => {
      //     console.error('Erro ao enviar:', error);
      //     alert('Ocorreu um erro ao enviar o formulário.');
      //   });
    },

    validaequipamentos() {
      for (let i = 0; i < this.equipamentos.length; i++) {
        const instalacao = this.equipamentos[i];
        if (Object.values(instalacao).some((value) => value === "")) {
          return true; // Retorna true se encontrar algum campo vazio
        }
      }
      return false;
    },
    maskTelefone() {
      let v = this.form.telefone.replace(/\D/g, "");

      if (v.length > 11) v = v.slice(0, 11);

      if (v.length > 10) {
        v = v.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
      } else if (v.length > 6) {
        v = v.replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
      } else if (v.length > 2) {
        v = v.replace(/^(\d{2})(\d{0,5})$/, "($1) $2");
      } else {
        v = v.replace(/^(\d*)$/, "($1");
      }

      this.form.telefone = v;
      this.saveLocal();
    },

    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !regex.test(this.form.email);
      this.saveLocal();
    },

    saveLocal() {
      // localStorage.setItem(
      //   "iluminacao_form",
      //   JSON.stringify({
      //     form: this.form,
      //     equipamentos: this.equipamentos,
      //   })
      // );
    },

    addCard() {
      this.equipamentos.push({
        dias_operacao: 0,
        horas_operacao: 0,
        quantidade: "",
        aplicacao: "",
        tecnologia: "",
        potencia: "",
      });
      this.saveLocal();
    },
    removeCard(index) {
      if (this.equipamentos.length === 1) return;

      this.equipamentos.splice(index, 1);
      this.saveLocal();
    },
  },

  mounted() {
    // const saved = localStorage.getItem("iluminacao_form");
    // if (saved) {
    //   const parsed = JSON.parse(saved);
    //   this.form = parsed.form || this.form;
    //   this.equipamentos = parsed.equipamentos || this.equipamentos;
    // }
    this.addCard();
  },
  directives: {
    money: VMoney,
    mask,
  },
  components: {
    BackSimulator,
  },
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

@import "@/theme/styles/base.scss";

.bg {
  min-height: 100svh;
  min-width: 100svw;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
}

.card-custom {
  backdrop-filter: blur(6px) brightness(0.8) !important;
  background: tint($body-color, 70%);
  border: 1px solid tint($brand-primary, 90%) !important;
  border-radius: 2.4rem !important;
  margin-bottom: -16px;

  .card-custom-text {
    padding: 16px !important;

    @media (min-width: 960px) {
      padding: 16px 16px 16px 16px !important;
    }
  }
}

.v-select__selection.v-select__selection--comma,
.v-input {
  font-size: 14px !important;
}

.v-text-field__details {
  display: none !important;
}

.primary {
  background-color: $brand-default !important;
  border-color: $brand-default !important;
}

.v-text-field input[type="number"]::-webkit-inner-spin-button,
.v-text-field input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.v-text-field input[type="number"] {
  -moz-appearance: textfield;
}

.responsive-container {
  max-width: 1264px;
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 960px) {
    max-width: 100%;
  }
}

.btn-plus {
  margin-top: 32px;
}
</style>
